// extracted by mini-css-extract-plugin
module.exports = {"spinner-border":"ONgGM","spinner-border-sm":"Cazlg","spinner-grow":"xSNrj","spinner-grow-sm":"O-6T6"};